import fetcher from "../helpers/fetcher";

export async function GetAllPartners(
  page,
  searchTerm = "",
  fetchAllInfo = true,
  networkFilter = ""
) {
  let path = `/partners?page=${page}&search=${searchTerm}&fetchAllInfo=${fetchAllInfo}&network=${networkFilter}`;
  let request = await fetcher(path, "GET");
  let content = await request.json();
  return content;
}

export async function AddPartner(body) {
  let path = `/partners`;
  let request = await fetcher(path, "POST", body);
  let content = await request.json();
  return content;
}

export async function GetPartnerDetails(id) {
  const path = `/partners/${id}`;
  const request = await fetcher(path, "GET");
  const content = await request.json();
  return content;
}

export async function EditPartnerDetails(id, body) {
  const path = `/partners/${id}`;
  const request = await fetcher(path, "PUT", body);
  const content = await request.json();
  return content;
}
